import api from './api';

export interface EmbeddingModelInfo {
  provider: string;
  vector_backend: string;
  available: boolean;
  model_id: string | null;
  model_tag: string | null;
  dimensions: number | null;
  distance: string | null;
  error?: string | null;
}

export interface LkbJob {
  status: string;
  mode?: string | null;
  total_documents?: number;
  processed_documents?: number;
  percentage?: number;
  docs_per_sec?: number | null;
  error_message?: string | null;
  stalled?: boolean;
  updated_at?: string | null;
  completed_at?: string | null;
}

export interface FailedDoc { id: string; patent_id?: string | null; title?: string | null; }

export interface LkbRow {
  kb_id: string;
  name: string | null;
  document_count: number;
  not_embedded: number;
  job: LkbJob;
}

export interface SweepHealth {
  enabled: boolean;
  running: boolean;
  interval_seconds: number;
  max_docs_per_kb: number;
  last_tick_started_at: string | null;
  last_tick_finished_at: string | null;
  last_tick_embedded: number;
  ticks_completed: number;
  last_tick_error: string | null;
  consecutive_failures: number;
  backoff_active: boolean;
  next_tick_in_seconds: number;
  backoff_after_failures: number;
  backoff_max_seconds: number;
  backlog_not_embedded: number;
}

export interface SkbVectorIndex {
  status?: string | null;
  store?: string | null;
  indexed_chunks?: number | null;
  total_chunks?: number | null;
  completed_at?: string | null;
  error?: string | null;
}

export interface SkbRow {
  kb_id: string;
  name: string | null;
  client_id: string | null;
  visibility: string | null;
  document_count: number;
  prepared_document_count: number | null;
  chunk_count: number | null;
  vector_index: SkbVectorIndex | null;
}

export interface ConsistencyRow {
  collection: string;
  kind: string;
  kb_id?: string;
  client_id?: string;
  qdrant_points: number | null;
  mongo_expected: number;
  delta: number | null;
  note_key?: string;
  error: string | null;
}

export interface QdrantConsistency {
  available: boolean;
  error: string | null;
  collections: ConsistencyRow[];
}

export interface CorpusInfo {
  estimated_document_count: number;
  status_counts: Record<string, number>;
  failed_sample: FailedDoc[];
  unassigned_pending: number;
}

export interface EmbeddingsOverview {
  generated_at: string;
  embedding_model: EmbeddingModelInfo;
  corpus: CorpusInfo;
  lkbs: LkbRow[];
  sweep: SweepHealth;
  skbs: SkbRow[];
  qdrant_consistency: QdrantConsistency;
}

export async function getEmbeddingsOverview(): Promise<EmbeddingsOverview> {
  const { data } = await api.get('/admin/embeddings/overview');
  return data;
}
